import React from 'react'
import { useState, useEffect } from 'react';
import { Breadcrumb, Button, Card, Col, Flex, Row, Space, Table, Typography } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { appointmentData } from '../../../Data';
import { TableLoader } from '../../../shared';
import { apiCalls } from '../../../shared/Apis';
const { Text } = Typography
const SingleViewPayment = () => {
    let { payId } = useParams()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [singleData, setSingleData] = useState(null)

    const SingleViewProject = async () => {
        setLoading(true)
        const result = await apiCalls?.Projectapi?.SingleViewProject(payId)
        if (result)
            setSingleData(result)
        setLoading(false)
    }

    useEffect(() => {
        SingleViewProject()
    }, [payId])
    const columns = [
        {
            title: 'Title',
            dataIndex: 'title',
            width: 150,
        },
        {
            title: 'Detail',
            dataIndex: 'detail',
            width: 150,
        },
    ];
    const data = [
        {
            key: '1',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Client Name</Text>
                <Text>
                    {singleData?.data?.client?.firstName?.charAt(0).toUpperCase() + singleData?.data?.client?.firstName?.slice(1)}{' '}
                    {singleData?.data?.client?.lastName?.charAt(0).toUpperCase() + singleData?.data?.client?.lastName?.slice(1)}
                </Text>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Professional Name</Text>
                <Text>
                    {singleData?.data?.professional?.firstName?.charAt(0).toUpperCase() + singleData?.data?.client?.firstName?.slice(1)}{' '}
                    {singleData?.data?.professional?.lastName?.charAt(0).toUpperCase() + singleData?.data?.client?.lastName?.slice(1)}
                </Text>
            </Space>,
        },
        {
            key: '2',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Client Email</Text>
                <Text>{singleData?.data?.client?.email}</Text>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Professional Email</Text>
                <Text>{singleData?.data?.professional?.email}</Text>
            </Space>,
        },
        {
            key: '2',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Client Contact Number</Text>
                <Text>{singleData?.data?.client?.phoneNo}</Text>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Professioanl Contact Number</Text>
                <Text>{singleData?.data?.professional?.phoneNo}</Text>
            </Space>,
        },
        {
            key: '3',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Start Date</Text>
                <Text>{singleData?.data?.date}</Text>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>End Date</Text>
                <Text>{singleData?.data?.endDate}</Text>
            </Space>,
        },
        {
            key: '4',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Services</Text>
                <Text>{singleData?.services?.map((item) => item.name)}</Text>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Description</Text>
                <Text>{singleData?.data?.description}</Text>
            </Space>,
        }
    ];

    return (
        <div>
            <Breadcrumb className='mb-3'
                separator=">"
                items={[
                    {
                        title: <Text className='cursor text-gray' onClick={() => navigate('/payment')}>Payment Details</Text>,
                    },
                    {
                        title: <Text className='fw-500'>
                            {singleData?.data?.client?.firstName?.charAt(0).toUpperCase() + singleData?.data?.client?.firstName?.slice(1)}{' '}
                            {singleData?.data?.client?.lastName?.charAt(0).toUpperCase() + singleData?.data?.client?.lastName?.slice(1)}
                        </Text>,
                    },
                ]}
            />
            <Card className='shadow-d radius-12 mb-3'>
                <Row gutter={[24, 24]}>
                    <Col span={24}>
                        <Space>
                            <Button className='border0 p-0 bg-transparent' onClick={() => navigate('/appointment')}>
                                <ArrowLeftOutlined />
                            </Button>
                            <Text className='fw-500'>
                                {singleData?.data?.client?.firstName?.charAt(0).toUpperCase() + singleData?.data?.client?.firstName?.slice(1)}{' '}
                                {singleData?.data?.client?.lastName?.charAt(0).toUpperCase() + singleData?.data?.client?.lastName?.slice(1)}
                            </Text>
                            {
                                singleData?.data?.status === 1 ? (
                                    <Text className='badge-cs pending fs-12'>Pending</Text>
                                ) : singleData?.data?.status === 2 ? (
                                    <Text className='badge-cs inactive fs-12'>On-going</Text>
                                ) : (
                                    <Text className='badge-cs active fs-12'>Complete</Text>
                                )
                            }
                        </Space>
                    </Col>
                    <Col span={24}>
                        <Table
                            size='large'
                            columns={columns}
                            dataSource={data}
                            scroll={{ x: 1000 }}
                            className='pagination'
                            showSorterTooltip={false}
                            rowHoverable={false}
                            showHeader={false}
                            pagination={false}
                        // loading={
                        //     {
                        //         ...TableLoader,
                        //         spinning: loading
                        //     }
                        // }
                        />
                    </Col>
                </Row>
            </Card>
        </div>
    )
}

export { SingleViewPayment }
